
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/articles/categories/[slug]",
      function () {
        return require("private-next-pages/articles/categories/[slug].page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/articles/categories/[slug]"])
      });
    }
  